export enum UtmEventType {
	PageVisit = 'page_visit',
	Registration = 'registration',
	LobbyJoin = 'lobby_join',
}
